import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { TopInstrument } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'saving-plans-saving-plan-most-chosen-item',
  templateUrl: './saving-plan-most-chosen-item.component.html',
  imports: [InstrumentDetailsLinkComponent, RouterLink, TranslocoPipe],
})
export class SavingPlanMostChosenItemComponent {
  @Input() public savingPlan: TopInstrument;

  public readonly savingPlanMaskUrl = commonRoutes.postlogin.add_savings_plan;
}
